<template>
  <transition name="fade">
    <div class="app-backdrop" v-if="show" @click.prevent="close"></div>
  </transition>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AppBackdrop',
    computed: {
      ...mapGetters('Popups', {
        show: 'hasShowPopups',
      })
    },
    methods: {
      close() {
        this.$store.commit('Popups/closeAllPopups')
        this.$store.commit('Certificate/setData', {});
      },
    }
  }
</script>
